import React from "react";

export function ResultsSkeleton() {
  return (
    <div className="mt-8 space-y-6">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="animate-pulse rounded-xl border border-gray-100 bg-white p-6"
        >
          <div className="flex items-start gap-4">
            <div className="h-10 w-10 rounded-lg bg-gray-200" />
            <div className="flex-1 space-y-3">
              <div className="h-4 w-1/3 rounded bg-gray-200" />
              <div className="space-y-2">
                <div className="h-3 w-full rounded bg-gray-100" />
                <div className="h-3 w-5/6 rounded bg-gray-100" />
              </div>
              <div className="flex gap-2">
                <div className="h-4 w-16 rounded-full bg-gray-100" />
                <div className="h-4 w-24 rounded-full bg-gray-100" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
